import { useState } from 'react';
import useGalleryScenes from '../hooks/useGalleryScenes';
import { useAtom } from 'jotai';
import { isMobile, showPanoramaViewAtom } from '../states/planner';
import tomodal from '../assets/tomodal.svg';

export const PanoramaButton = () => {
  const [galleryScenes] = useGalleryScenes('cube');
  const [, setShowPanoramaView] = useAtom(showPanoramaViewAtom);
  const [clicked, setClicked] = useState(false);

  if (!galleryScenes || galleryScenes.length === 0) return null;

  const handleClick = () => {
    if (isMobile()) {
      setClicked(true);

      setTimeout(() => {
        setClicked(false);
        setShowPanoramaView(true);
      }, 450);
    } else {
      setShowPanoramaView(true);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`relative bottom-0 left-2 flex w-auto items-center gap-1.5 whitespace-nowrap rounded-md bg-black bg-opacity-50 px-2 py-0.5 text-white opacity-90 sm:origin-center sm:transform sm:gap-2 sm:px-3 sm:py-1 sm:text-sm sm:transition sm:duration-100 sm:hover:scale-105 ${clicked ? 'scale-95 bg-[#00965f]/80' : ''}`}
    >
      Galleri
      <img src={tomodal} alt="open modal" />
      {clicked && <span className="absolute inset-0 animate-ping rounded-md bg-white/30"></span>}
    </button>
  );
};
